var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"py-5 mb-5 mt-5 d-flex justify-content-center custom-container"},[_c('VerifyForm',{attrs:{"field":_vm.$route.params.field}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }